import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-back-button',
  standalone: true,
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  host: {
    'role': 'button',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent {

  public readonly text = input<string>('Close');

}
